/** Longest chat title stored in chats.name. Shared by the client and server. */
export const MAX_CHAT_TITLE_LENGTH = 60;
